<template>
    <div
        role="alert"
        class="alert"
        v-bind:class="{
            'alert-info': !confirmed && !confirmed,
            'alert-success': confirmed,
            'alert-danger': cancelled,
        }"
    >
        <div v-if="confirmed">
            <i class="fas fa-check mr-1"></i> Seu pagamento foi confirmado!
        </div>
        <div v-else-if="cancelled">
            <i class="fas fa-times mr-1"></i>
            Seu pagamento não foi aprovado. Em caso de dúvida, entre em contato com o suporte.
        </div>
        <div v-else>
            <i class="fas fa-circle-notch fa-spin mr-1"></i> Verificando o seu pagamento...
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            confirmed: {
                type: Boolean,
                default: false
            },
            cancelled: {
                type: Boolean,
                default: false
            },
        }
    }
</script>
